import http from '~/common/http'

export const TYPE_TRACE = 1; // 跟进任务(业务员跟进，填写跟进记录)
export const TYPE_AUDIT = 2; // 审核任务(业务主管、总监对订单审核)
export const TYPE_CHECK = 3; // 核对任务
export const TYPE_CALLBACK = 4; // 回访任务

export const STATUS_ONGOING = 0; //进行中
export const STATUS_FINISHED = 1; // 已完成
export const STATUS_CANCEL = 2; // 已取消
export const STATUS_DELETED = 3; // 已删除
export const STATUS_UNFINISHED = 4; // 未完成状态

const Model = {
    id: 0,
    subject: "",
    customer_id: 0,
    customer_name: "",
    type: "",
    executor_id: 0,
    memo: ""
};

export default {

    /**
     * 人工创建任务
     * @param {int} task
     */
    create(task) {
        return http.post('/api/tasks/create', task);
    },

    /**
     * 更新任务
     * @param {int} task
     */
    update(task) {
        return http.put('/api/tasks/update?id=' + task.id, task);
    },

    /**
     * 删除任务
     * @param {int} taskId
     */
    delete(taskId) {
        return http.delete('/api/tasks/delete?id=' + taskId);
    },

    /**
     * 取消任务
     * @param {int} taskId
     */
    cancel(taskId) {
        return http.put('/api/tasks/cancel?id=' + taskId);
    },

    done(data) {
        return http.post('/api/tasks/done', data);
    },

    /**
     * 获取任务列表
     * @param {object} params
     */
    getTaskList(params) {
        return http.get('/api/tasks/index', {params: params});
    },

    /**
     * 获取任务详情
     * @param {int} taskId
     */
    getTaskDetail(taskId) {
        return http.get('/api/tasks/view', {
            params: {
                id: taskId
            }
        });
    },

    /**
     * 获取任务模型对象
     * @returns {{id: number, subject: string, customer_id: number, customer_name: string, type: string, executor_id: number, memo: string}}
     */
    getModel() {
        return Model;
    },

    /**
     * 获取任务类型列表
     * @returns {{[p: string]: string, [p: number]: string}}
     */
    getTypes() {
        return {
            [TYPE_TRACE]: "跟进任务",
            [TYPE_AUDIT]: "审核任务",
            [TYPE_CHECK]: "核对任务",
            [TYPE_CALLBACK]: "回访任务"
        }
    },

    /**
     * 获取任务类型备注
     * @param key
     * @returns {*}
     */
    getTypeMemo(key) {
        let types = this.getTypes();
        return types[key] ? types[key] : "";
    },

    //得到客户筛选项配置
    getFields(path, active_name) {
        return [
            {field: 'base', label: '基础信息筛选条件', children: [
                {field: 'name', label: '客户名称', type: 'components', ref: 'customer', components: 'CustomerSelect', change: 'changeObjValue'},
                {field: 'type', label: '任务类型', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '跟进任务'}, {value: 2, label: '审核任务'}, {value: 3, label: '核对任务'}, {value: 4, label: '回访任务'}]},
                {field: 'status', label: '任务状态', type: 'select', list: [{value: '', label: '不限'}, {value: 0, label: '进行中'}, {value: 1, label: '已完成'}, {value: 2, label: '已取消'}, {value: 3, label: '已删除'}, {value: 4, label: '未完成'}]},
                active_name == 'MyTask' ? {field: 'creator_id', label: '创建人', type: 'components', ref: 'creator', components: 'UserSelect', change: 'changeObjLabel'} : null,
                active_name == 'MyCreated' ? {field: 'executor_id', label: '执行人', type: 'components', ref: 'executor', components: 'UserSelect', change: 'changeObjLabel'} : null,
            ]},
            {field: 'date', label: '时间筛选条件', children: [
                {field: 'created_at', label: '创建时间', type: 'daterange'},
            ]},
        ];
    },
}


// WEBPACK FOOTER //
// ./src/services/task.js